import summaryIcon from "../assets/summary.png";

const DetailItem = ({ label, value }) => (
  <div className="flex flex-col items-center text-center">
    <p className="font-bold text-[#FF9533] text-xs md:text-sm xl:text-base pb-1 uppercase">
      {label}
    </p>
    <p className="text-boldGray opacity-90">{value}</p>
  </div>
);

const SummaryHeader = () => (
  <div className="flex items-center">
    <img
      src={summaryIcon}
      alt="Resumo"
      className="w-[50px] h-[60px] md:w-[40px] md:h-[50px]"
    />
    <p className="ml-3 text-[#2F2E41] font-bold text-xl md:text-lg xl:text-2xl">
      Resumo
    </p>
  </div>
);

const OrderDetails = ({ qtd, total, valor }) => {
  return (
    <div className="mt-2 bg-[#F9F9F9] p-4 md:p-2 xl:p-4 rounded-lg overflow-hidden">
      <div className="flex flex-wrap items-center justify-between">
        <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
          <SummaryHeader />
        </div>

        <div className="flex flex-1 justify-around">
          <DetailItem label="Quantidade" value={qtd} />
          <DetailItem label="Total dos pedidos" value={total} />
          <DetailItem label="Valor a pagar" value={valor} />
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
